export default __webpack_public_path__ + "static/media/63.5772eda3.gif";